import { isOldVmRetired, isOperatorCreatedAfterMigration, OLD_VM_RETIREMENT_DATE_SHORT } from "@/constants/vehicleMigration";
import { EPermission } from "@/permissions/types";
import { Tab } from "./types";

export const getMenuNavigation = (operatorId: string, operatorJoined?: string) => {
  const navigation: Tab[] = [
    {
      name: "Get Started",
      to: "/get-started",
      icon: "iconsax-sparkle",
      isCustomIcon: true,
      permission: EPermission.ProviderGetStartedManage,
      adminOnly: true,
    },
    {
      name: "Quick Setup",
      to: "/quick-setup",
      icon: "iconsax-sparkle",
      isCustomIcon: true,
      permission: EPermission.ProviderQuickSetupManage,
      adminOnly: true,
    },
    {
      name: "Bookings",
      to: "/bookings",
      icon: "ArchiveBook",
      badge: "16",
      permission: EPermission.ProviderBookingMgrManage,
    },
    {
      name: "Vehicles",
      ...(isOldVmRetired() || (operatorJoined && isOperatorCreatedAfterMigration(operatorJoined))
        ? {}
        : { subtitle: "New vehicle manager", badge: "New", badgeType: "new" as const }),
      to: "/vehicles",
      icon: "Car",
      permission: EPermission.ProviderVehicleManagerManage,
    },
    ...(!isOldVmRetired() && !(operatorJoined && isOperatorCreatedAfterMigration(operatorJoined))
      ? ([
          {
            name: "Vehicles",
            subtitle: "Old vehicle manager",
            to: "/vehicles-legacy",
            legacyTo: `/o/${operatorId}/config/vehicle-manager`,
            icon: "car-slash",
            isCustomIcon: true,
            badge: OLD_VM_RETIREMENT_DATE_SHORT,
            badgeType: "countdown",
            permission: EPermission.ProviderVehicleManagerManage,
            legacyPermission: ["manage", "legacyProviderVehicleManager"],
          },
        ] as Tab[])
      : []),
    {
      name: "Drivers",
      to: "/drivers",
      icon: "driver-wheel",
      isCustomIcon: true,
      badge: "12",
      permission: EPermission.ProviderDriverManage,
    },
    {
      name: "Clients",
      to: "/clients",
      icon: "Profile2User",
      badge: "5",
      permission: EPermission.ProviderClientManage,
    },
    {
      name: "Companies",
      to: "/companies",
      icon: "Buildings",
      permission: EPermission.ProviderCompanyManage,
    },
    {
      name: "Payments",
      to: "/payments",
      icon: "DollarCircle",
      permission: EPermission.ProviderPaymentsView,
    },
  ];

  return navigation;
};

export const getMoreNavigation = () => {
  const navigation: Tab[] = [
    {
      name: "RM Network",
      to: "/rm-network",
      icon: "Global",
      permission: EPermission.ProviderPrivateNetworkManage,
    },
    {
      name: "External Suppliers",
      to: "/external-suppliers",
      icon: "People",
      badge: "5",
      permission: EPermission.ProviderExternalSupplierManage,
    },
    // {
    //   name: "Accreditations",
    //   to: "/accreditations",
    //   icon: "LikeTag",
    //   permission: ["manage", "providerAccreditations"],
    //   isDashboard: true,
    // },
    {
      name: "Rating Manager",
      to: "/rating-manager",
      icon: "Star1",
      permission: EPermission.ProviderRatingManagerView,
    },
    {
      name: "Trip Reporting",
      to: "/trip-reporting",
      icon: "DocumentText",
      permission: EPermission.ProviderReportingTripManage,
    },
    {
      name: "Settings",
      to: "/config",
      icon: "Setting2",
      permission: EPermission.ProviderConfigView,
    },
    {
      name: "Add Ons",
      to: "/add-ons",
      isCustomIcon: true,
      icon: "rocket",
      permission: EPermission.ProviderAddOnsManage,
      adminOnly: true,
    },
    {
      name: "Help",
      icon: "Lifebuoy",
      to: "",
      onClick: () => {
        // console.log("Tracking: Resource Center Triggered", "resource_center:6M4ZcjVqyD");
      },
      isUnderReview: true,
    },
  ];

  return navigation;
};
